import {useNavigate} from 'react-router-dom';
import React from 'react';
import InfinitScroll from 'components/infinitScroll';
import MainCardSwitcher from 'components/mainCards';
import EmptyPost from 'assets/images/emptyPage/empty page.svg';
interface PostsProps {
  posts: IResultsPostLis[] | undefined;
  isloading: boolean;
  onWatchEnd: () => void;
  app: string;
}
const Posts = ({posts, isloading, onWatchEnd, app}: PostsProps) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-wrap overflow-visible justify-center w-full gap-4 ">
      <InfinitScroll isloading={isloading} onWatchEnd={onWatchEnd}>
        {posts?.length === 0 ? (
          <div className=" mt-28">
            <img src={EmptyPost} alt="empty" className=" block mx-auto" />
            <p className=" text-gray-5 text-center">
              موردی برای نمایش وجود ندارد.
            </p>
          </div>
        ) : (
          posts?.map(item => {
            return (
              <button
                onClick={() =>
                  navigate(
                    `/${app === 'market' ? 'wholesaler' : 'farm'}/${
                      item.type
                    }/${item.guid}`,
                    {
                      state: {
                        guid: item.guid,
                      },
                    },
                  )
                }
                key={item.guid}
                className="flex  w-full justify-center"
              >
                <MainCardSwitcher
                  subtype={item.type}
                  type={item.post_type}
                  post={{
                    isExpired: item?.[item.type]?.is_expired
                      ? item?.[item.type]?.is_expired
                      : '',
                    isSold: item.sale_status?.is_saled || false,
                    title: item.title,
                    image: item.main_image?.image_128,
                    created_at: item.created_at,
                    state: item.state ? item.state : '',
                    city: item.city ? item.city : '',
                    grade: item.grade ? item.grade : '',
                    price: item.price,
                    expire_date: item?.[item.type]?.expire_date
                      ? item?.[item.type]?.expire_date
                      : '',
                    size: item.cultivation_area ? item.cultivation_area : 0,
                    proposal: item.suggestions ? item.suggestions : 0,
                    negotiated_price: item.negotiated_price,
                    sale: item.sale,
                    is_distinguished: item.is_distinguished,
                  }}
                />
              </button>
            );
          })
        )}
      </InfinitScroll>
    </div>
  );
};
export default Posts;
